import { render } from "./opTableServerSide.vue?vue&type=template&id=4c7a5a0b&ts=true"
import script from "./opTableServerSide.vue?vue&type=script&lang=ts"
export * from "./opTableServerSide.vue?vue&type=script&lang=ts"

import "./opTableServerSide.vue?vue&type=style&index=0&id=4c7a5a0b&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__